import SupervisorAccount from '@material-ui/icons/SupervisorAccount';

import List from './List2';

export default {
  list: List,
  icon: SupervisorAccount,
};
